<template>
    <v-layout>
        <v-flex>
            <v-card style="width: 50%; margin: auto;">
              <v-card-title class="white--text tertiary">
                <h1>Change Your Associated Email Address</h1>
                <h2>Current Email Address "{{ currentEmail }}"</h2>
              </v-card-title>
              <v-card-text>
                <p>You've requested a change in the email address associated to your account.</p>
                <v-text-field
                    v-model="newEmail"
                    label="New Email Address"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="newEmailConfirm"
                    label="Confirm New Email Address"
                    required
                ></v-text-field>
                <p class="red--text">If you did not request this change of associated email address, please contact support at customerportal@danielshealth.ca</p>
              </v-card-text>
              <v-card-actions>
                  <v-btn class="white--text accent">
                      Save New Email
                  </v-btn>
              </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>    
</template>

<script>
export default {
    name: "ChangeEmail",
    data() {
        return {
            currentEmail: null,
            newEmail: null,
            newEmailConfirm: null
        }
    }
}
</script>

<style scoped>

</style>